import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import Spacer from '../../components/spacer'
import css from './style.css'
import CaratSection from './carat_section'
import ClaritySection from './clarity_section'
import ColourSection from './colour_section'
import FlourescenceSection from './flourescence_section'
import CutSection from './cut_section'
import GradingLabSection from './grading_lab_section'
import DiamondShapesSection from './diamond_shapes_section'
import TitleSection from './title_section'

const Diamond = props => (
  <div className={css.outerContainer}>
    <div className={css.innerContainer}>
      <TitleSection {...props} />
      <Spacer xl />
      <DiamondShapesSection {...props} />
      <Spacer xl />
      <Spacer xl />
      <GradingLabSection {...props} />
      <Spacer xl />
      <Spacer xl />
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <div className={css.centeredTitle}>
            The 4Cs: Carat, Cut, Clarity, Colour
          </div>
        </GridItem>
      </Grid>
      <Spacer xl />
      <CaratSection {...props} />
      <Spacer xl />
      <CutSection {...props} />
      <Spacer xl />
      <ClaritySection {...props} />
      <Spacer xl />
      <ColourSection {...props} />
      <Spacer xl />
      <Spacer xl />
      <FlourescenceSection {...props} />
      <Spacer xl />
    </div>
  </div>
)

export default Diamond



// WEBPACK FOOTER //
// ./src/containers/diamond/index.js